import { render, staticRenderFns } from "./autologin.vue?vue&type=template&id=a4efa99c&"
import script from "./autologin.vue?vue&type=script&lang=ts&"
export * from "./autologin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports